import { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UITourCancelButton from 'ui-shepherd-react/button/UITourCancelButton';
import { Text } from 'foundations-components/components/Text';
import { ONBOARDING_FORECAST_REP_TABLE } from '../../constants/TourConstants';
import { REP_OVERVIEW } from '../../constants/Events';
import { trackCancelUITour, trackNextStepUITour } from '../../utils/usageTracker';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OnboardingRepTableTourStep = ({
  children
}) => {
  const {
    tour
  } = useContext(TourContext);
  const isDealStageView = useSelector(getIsDealStageView);
  const tourKey = tour.getTour();
  if (!tourKey) {
    return children;
  }
  return /*#__PURE__*/_jsx(UITourStep, {
    tourKey: tourKey,
    stepKey: ONBOARDING_FORECAST_REP_TABLE,
    showSteps: true,
    placement: "bottom",
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-primary-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.onboarding.repTable.header"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tour.onboarding.repTable.body"
      }),
      footer: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(UITourCancelButton, {
          beforeCancel: () => trackCancelUITour(ONBOARDING_FORECAST_REP_TABLE, REP_OVERVIEW, isDealStageView),
          size: "small"
        }), /*#__PURE__*/_jsx(UITourNextButton, {
          beforeNext: () => trackNextStepUITour(ONBOARDING_FORECAST_REP_TABLE, REP_OVERVIEW, isDealStageView),
          use: "primary",
          size: "small"
        })]
      })
    },
    children: children
  });
};
OnboardingRepTableTourStep.propTypes = {
  children: PropTypes.node.isRequired
};
export default OnboardingRepTableTourStep;